export default {
  hero_title: 'Welcome Back!',
  hero_subtitle: 'Keep your face always toward the sunshine - and shadows will fall behind you.',
  title: 'Login to Estimator24 Account',
  subtitle: 'Enter your credentials to continue.',
  email: 'Email address',
  password: 'Password',
  remember_me: 'Remember me',
  submit: 'Sign in',
  register_link: 'Create an account'
}
